export { default } from "../routes/error";
